export default "__VITE_ASSET__d5f92c52__"